var watchlistCreate = {
	confirmBtn: "Ok",
	cancelBtn: "Cancel",
	title: "Create a new watchlist",
	placeholder: "Name",
	nameInputLabel: "Watchlist Name",
	nameInputTip: "Max. 100 characters – Valid characters: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	validationErrors: {
		name: {
			invalidInput: "Name is invalid. Max. 100 characters – Valid characters: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var en = {
	watchlistCreate: watchlistCreate
};

export { en as default, watchlistCreate };
